/*
Item: Upload components
Name: Upload
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import PropTypes from 'prop-types';
import { Growl } from 'primereact/growl';
import { postImportInit, postImportData, postImportInsert } from '../service/UploadService';
import UploadMessage from './UploadMessage';
import { DateTimeUtils } from '../utils/DateTimeUtils';
import MessageService from '../service/MessageService';
import JsonHelper from '../utils/statisticsUtils';

const ACCEPTED = ['csv', 'txt']; // change from mime-type to file-extension

// checks if fileList contains a file, prevents unintended upload triggers
function hasFile(fileList) {
  return fileList.length > 0 && fileList[0];
}

// checks file extension by comparing extension against an array of accepted file extensions
function isValidExtension(file) {
  const fileName = file.name;
  const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || '';
  return fileExtension !== '' && ACCEPTED.includes(fileExtension);
}

// checks if there is a file in fileList and if it has a valid extension
function fileIsValid(fileList) {
  return hasFile(fileList) && isValidExtension(fileList[0]);
}

function readFileAsync(file, charset) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsText(file, charset);
  });
}

/**
 * @description Component which offers the possibility to import files in
 * "Fachadminestrator -> Import"
 */
export default class Upload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      file: '',
      infoMessage: '',
      visible: false,
      severity: 'info',
      uuid: sessionStorage.getItem('uuid'),
      fileDTO: '',
      /* uploadDisabled: true, */
      fileDisabled: false,
    };
    this.messageService = new MessageService();
    // this.UploadService = new UploadService();
    this.DateTimeUtils = new DateTimeUtils();
    // this.readFile = this.readFile.bind(this);
    this.closeMessage = this.closeMessage.bind(this);
  }

  fileUpload = async () => {
    let ret;
    const { formValues } = this.props;
    let importModeModified = formValues.inputMode;
    if (formValues.importNewFlag) { importModeModified = 'NEW'; }
    if (formValues.importModifyFlag) { importModeModified = 'UPDATE'; }
    if (formValues.importNewFlag && formValues.importModifyFlag) { importModeModified = 'MERGE'; }
    formValues.importMode = importModeModified;
    // todo check if both ifs and their contents are necessary
    if (formValues.startTime) {
      formValues.startTimePass = formValues.startTime + ':00';
      // formValues.startTimePass = `${this.DateTimeUtils.convertDate(formValues.startTime)} ${this.DateTimeUtils.convertTime(formValues.startTime)}`;
    }
    /*
    if (formValues.endTime) {
      const tmpTimeDate = formValues.endTime;
      if (formValues.startTime.getTime() > tmpTimeDate.getTime()) {
        tmpTimeDate.setDate(tmpTimeDate.getDate() + 1);
      }
      formValues.endTimePass = `${this.UploadService.convertDate(tmpTimeDate)} ${this.DateTimeUtils.convertTime(tmpTimeDate)}`; // todo this method does not exit?!
    }
    */
    let infoMessage;
    let severity;
    console.log('VALUES#', formValues);
    // upload file for data import or ptable, not Metadata
    if (formValues.dataSelection !== 'Metadaten' && formValues.dataSelection !== 'Regeln' && formValues.dataSelection !== 'Datenquader') {
      const { file } = this.state;
      // const prefix = file.name.split('_')[0];
      let urlpath = 'file';
      if (formValues.dataSelection === 'PTable') {
        const fileContent = await readFileAsync(file, formValues.charset);
        const fileContentArr = fileContent.split('\r\n');
        const firstRowOfFile = fileContentArr[0].split(';');
        // check if file is correct type -> PTable = 4 elements for each row
        if (firstRowOfFile.length === 5 || firstRowOfFile.length === 6) {
          // if (prefix.toLowerCase() === 'ptable') urlpath = 'ptable';
          urlpath = 'ptable'; // ticket 776
          ret = await postImportData(
            file, `${urlpath}/load_import`, formValues,
          );
        } else {
          ret = ['Die zu importierende Datei entspricht nicht dem zulässigen Format einer PTable.', 'error'];
        }
      } else {
        if (formValues.deleteTimeSlicesFirst) {
          // to get filename without the type ending (.csv)
          // const plainFileName = file.name.split('.')[0];
          // const ret2 = await this.messageService.getUploadDelete(plainFileName);
          const ret2 = await this.messageService.getUploadDelete(file.name);

          if (ret2[1]) {
            this.growl.show({ severity: ret2[1], summary: 'Fehler', detail: ret2[0] });
            ret = ['Regionalzeitscheibe konnte nicht gefunden und gelöscht werden.', 'error'];
          } else {
            this.growl.show({ severity: 'success', summary: 'Speichern', detail: 'Regionalzeitscheibe wurde gelöscht.' });

            ret = await postImportData(
              file, `${urlpath}/load_import`, formValues,
            );
          }
        } else {
          ret = await postImportData(
            file, `${urlpath}/load_import`, formValues,
          );
        }
      }
    } else {
      // create upload order for meta data or rules or datenquader
      const {
        fileDTO, file, content,
      } = this.state;
      ret = await postImportInsert(
        fileDTO,
        file.name,
        content,
        formValues,
        'import/insert',
      );
    }
    if (ret[1]) {
      [infoMessage, severity] = ret;
      this.setState({ spinVisible: false });
    } else {
      infoMessage = 'Auftrag erstellt';
      severity = 'success';
      this.setState({ spinVisible: false });
      this.refs.fileInput.value = null;
    }
    this.setState({
      file: '',
      content: '',
      infoMessage,
      visible: true,
      severity,
    });
  }

  // called when user selected a file, prevents default events from triggering,
  // checks file and loads file content
  onFileSelect = async (e) => {
    const { formValues } = this.props;
    this.setState({ spinVisible: true });
    try {
      e.stopPropagation();
      e.preventDefault();
      if (fileIsValid(e.target.files)) {
        const selectedFile = e.target.files[0];
        const fileContent = await readFileAsync(selectedFile, formValues.charset);
        let userData = await postImportInit();

        // fix for ticket 512
        userData = JsonHelper.deepCopy(userData);
        userData.contents['genesis.container.content.GenesisTMContent'].transfermodel.removeOwner = true;

        this.setState({
          file: selectedFile,
          infoMessage: '',
          visible: false,
          fileDTO: userData,
          content: fileContent,
        });
      } else {
        this.setState({ infoMessage: 'Ungültige Datei', visible: true });
      }
    } catch (err) {
      this.setState({ infoMessage: 'Fehler beim Laden der Datei', visible: true });
    } finally {
      this.setState({ spinVisible: false });
    }
  }

  disableCancel() {
    const { file } = this.state;
    return file === '';
  }

  disableUpload() {
    const { file } = this.state;
    const { formValues } = this.props;
    return !(file !== ''
      && (formValues.importNewFlag || formValues.importModifyFlag)
      && (formValues.dataSelection !== ''));
  }

  // reads the file contents - not used since readAsync function was introduced.
  /* readFile(event) {
    return event.target.result;
  } */

  // opens the browser file select dialogue
  openDialogue() {
    // eslint-disable-next-line react/no-string-refs
    this.refs.fileInput.click();
  }

  // removes file from fileList
  removeFile() {
    // eslint-disable-next-line react/no-string-refs
    this.refs.fileInput.value = null;
    this.setState({
      file: '',
      content: '',
      infoMessage: 'Datei entfernt',
      visible: true,
      severity: 'success',
    });
  }

  // checks if a file is present and calls the fileUpload method
  uploadFile() {
    const { file } = this.state;
    if (file) {
      try {
        this.setState({ spinVisible: true });
        this.fileUpload();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Error in Upload (fileUpload)', err);
      } finally {
        this.setState({
          spinVisible: false,
         });
      }
    } else {
      this.setState({ infoMessage: 'Es wurde keine Datei ausgewählt!', visible: true, severity: 'error' });
    }
  }

  // hides the info messages
  closeMessage() {
    this.setState({ visible: false });
  }

  render() {
    const {
      fileDisabled,
      file,
      visible,
      infoMessage,
      severity,
      spinVisible,
    } = this.state;
    return (
      <div className="p-fileupload">
        <div>
          <Growl style={{ position: 'absolute', left: '78.5%', top: '345px' }} ref={(el) => { this.growl = el; }} />
        </div>
        <Dialog header="Aktualisiere Ansicht..." closable={false} closeOnEscape={false} visible={spinVisible} modal onHide={() => this.setState({ visible: false })}>
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        <div className="p-toolbar">
          <Button
            type="none"
            id="file"
            disabled={fileDisabled}
            className="p-button-info"
            label="Datei auswählen"
            icon="pi-md-add"
            onClick={() => this.openDialogue()}
          />
          {/* The following input component is invisible. It stores the choosen file and
              handles changes if necessary.
              code can be changed if a better solution is availables
              Todo: try to improve it
           */}
          <input
            type="file"
            id="inputFile"
            ref="fileInput"
            name={file.name}
            accept=".csv, .txt"
            onChange={this.onFileSelect.bind(this)}
            hidden
          />
          <Button
            type="none"
            id="upload"
            disabled={this.disableUpload()}
            className="p-button-success"
            label="Importieren"
            icon="pi-md-file-upload"
            onClick={() => this.uploadFile()}
          />
          <Button
            type="none"
            id="abort"
            disabled={this.disableCancel()}
            className="p-button-danger"
            label="Abbrechen"
            icon="pi-md-close"
            onClick={() => this.removeFile()}
          />
        </div>
        <div className="p-fileupload-content">
          {file ? (
            <div>
              <span>
                Art:
                {file.type}
              </span>
              <br />
              <span>
                Name:
                {file.name}
              </span>
              <br />
              <span>
                Größe:
                {file.size}
              </span>
              <br />
              <span>
                Zuletzt geändert:
                {Date(file.lastModified)}
                {' '}
                {/* todo file.lastModified is invalid */}
              </span>
            </div>
          ) : ' '}
          <UploadMessage
            visible={visible}
            infoMessage={infoMessage}
            closeMessage={this.closeMessage}
            severity={severity}
          />
        </div>
      </div>
    );
  }
}

Upload.propTypes = {
  formValues: PropTypes.instanceOf(Object).isRequired,
};
